export const validatePrepareReturnSelection = (
    cargoShipmentCodeArray: any[] | undefined,
    isExcelExported: boolean
): { ok: true } | { ok: false; title: string; text: string } => {
    if (!cargoShipmentCodeArray || cargoShipmentCodeArray.length === 0) {
        return {
            ok: false,
            title: 'Uyarı',
            text: 'Seçili bir kargo bulunmamaktadır.',
        };
    }

    if (!isExcelExported) {
        return {
            ok: false,
            title: 'Uyarı',
            text: "Önce Excel'e indirmelisiniz.",
        };
    }

    return { ok: true };
};

export const mapReturnToSellerRows = (deliveryListShippingLists: any[]) =>
    deliveryListShippingLists.map((item: any) => ({ ...item, id: item.cargoShipmentCode }));

export const resolveSelectedReturnRows = (model: any[], datasFirst: any[]) =>
    model.map((id: any) => datasFirst.find((city: any) => city.id === id));
